module.exports = __webpack_public_path__ + "static/purchasing-a-home-square-1080w-ea700c6b8aa29aa12372aa1c4867b5f9.jpg";